'use strict'
// import axios from 'axios'
import { getItems, totalAmount, getOrder } from '../../services/shopping-cart'
import { default as swal } from 'sweetalert2'
import {HTTP} from '../../services/account-services.js'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import VueLadda from 'vue-ladda'
Vue.use(Vue2Filters)

export default {
  components: {
    'vue-ladda': VueLadda
  },
  data() {
    return {
      paymentMethods: {},
      loading: true,
      load: false,
      load1: false,
      load2: false,
      hasNoPayment: false,
      hasPayment: false,
      url: '',
      method: '',
      lcphone: '',
      lcpin: '',
      selectedMethodId: 0,
      rate: '',
      total: totalAmount(),
      currency: '',
    }
  },
  mounted() {
    this.currency = getOrder().currency
    this.getPaymentMethod()
    this.getRate()
  },
  methods: {
    getPaymentMethod() {
      let token = localStorage.getItem('authToken')
      let userId = localStorage.getItem('userId')
      let app = this
      let url = `/accounts/${userId}/paymentMethods?access_token=${token}`
      HTTP.get(url).then((response) => {
        app.paymentMethods = response.data
        if (response.data.wallets.length === 0 & response.data.cards.length === 0 & response.data.banks.length === 0 & response.data.gifts.length === 0) {
          app.hasNoPayment = true
          app.hasPayment = false
          app.loading = false
        } else {
          let wallets = response.data.wallets
          if (wallets.length > 0) {
            wallets.forEach((wallet) => {
              wallet.last4 = wallet.phoneNumber.substr(7, 12)
            })
          }
          app.hasPayment = true
          app.loading = false
        }
        console.log(response.data)
      }).catch((error) => {
        console.error('Error', error)
        swal(
          'Error',
          'Your session has expired. You will be redirected to login page to continue',
          'error'
        ).then((result) => {
          localStorage.removeItem('authToken')
          localStorage.removeItem('userId')
          this.$router.push('/login')
        })
      })
    },
    makePayment() {
      if (this.method.provider === 'lajancash') {
        // Show the modal to enter PIN Code for authorization
        $('#pin_lajancash').modal()
      } else {
        // Show modal rate
        $('#rate').modal()
      }
    },
    getRate() {
      let url = '/exchange-rates/1'
      HTTP.get(url).then((response) => {
        this.rate = response.data.rates.HTG
        console.log(response.data.rates.HTG)
      })
    },
    lajanCashPayment() {
      this.load2 = true
      let cart = getOrder()
      let redirectUrl = cart.returnUrl
      let userId = localStorage.getItem('userId')
      let _total = totalAmount()
      let order = {
        'payment': {
          'phoneNumber': this.method.phoneNumber,
          'provider': this.method.provider,
          'credentials': {
            'pincode': this.lcpin
          }
        },
        'items': getItems().items,
        'total': Math.round(_total * this.rate),
        'currency': 'htg',
        'accountId': userId,
        'merchantId': cart.merchantId,
        'orderId': cart.orderId
      }
      console.log('LAJANCASH_ORDER', order)
      HTTP.post('/payments', order).then((response) => {
        console.log('Payment response', response)
        console.log(response.status)
        $('#pin_lajancash').modal('hide')
        if (!response.data.charge.paid) {
          swal(
            'Payment failed',
            response.data.payment.outcome,
            'error'
          )
        } else {
          let cart = []
          swal(
            'Success',
            'Your order has been submitted successfuly. You will be redirected to merchant website',
            'success'
          ).then(function(redirect) {
            console.log('Redirect url', redirectUrl)
            location.replace(redirectUrl)
            localStorage.removeItem('order')
          })
        }
      })
    },
    otherPayment() {
      this.load1 = true
      let cart = getOrder()
      let redirectUrl = cart.returnUrl
      let userId = localStorage.getItem('userId')
      let order = {
        'payment': this.method,
        'items': getItems().items,
        'total': totalAmount(),
        'currency': cart.currency || 'htg',
        'accountId': userId,
        'merchantId': cart.merchantId,
        'orderId': cart.orderId
      }
      console.log('OTHER_PAYMENT', order)
      HTTP.post('/payments', order).then((response) => {
        $('#rate').modal('hide')
        console.log('Payment response', response)
        if (response.data.charge.paid) {
          console.log(response.status)
          let cart = []
          localStorage.setItem('cart', JSON.stringify(cart))
          swal(
            'Success',
            'Your order has been submitted successfuly. You will be redirected to merchant website',
            'success'
          ).then(function(redirect) {
            console.log('Redirect url', redirectUrl)
            location.replace(redirectUrl)
            localStorage.removeItem('order')
          })
        }
        if (response.data.status === 'payment_failed') {
          console.log(response.data.status)
          swal(
            'Error!',
            'We are sorry, but your payment can\'t be process now',
            'error'
          )
        }
      }).catch((error) => {
        console.error('Error', error)
        $('#rate').modal('hide')
        let errorMessage = `Payment can't be processed now.`
        if (error.message === 'Unknown client account') {
          errorMessage = `${errorMessage} Your card was not charged.`
        } else {
          errorMessage = `${errorMessage}. Your card was declined.`
        }
        swal(
          'Error',
          errorMessage,
          'error'
        ).then((result) => {
          location.reload()
        })
      })
    },
    selectedMethod(id) {
      this.selectedMethodId = id
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentMethods/PaymentMethods.js